/**
 * ServicePropertySwitchSettings содержит настройки для поля типа переключатель.
 */
export class ServicePropertySwitchSettings {
  /**
   * Variant задает вариант отображения поля.
   *  - single - одиночный чекбокс с одинарным состоянием, либо да, либо нет
   *  - both - три чекбокса, позволяющих выбрать какие варианты отображать,
   *    только да, только нет, оба варианта
   */
  public Variant: "both" | "single" = "both"

  /**
   * Тексты вариантов для отображения в виде 3х чекбоксов.
   * Можно задавать код локализации.
   */
  public BothVariantDisabledText: string = ""
  public BothVariantEnabledText: string = ""
  public BothVariantBothText: string = ""

  /**
   * Стиль отображения элементов для варианта отображения трех чебоксов.
   * - checkbox - в виде галок
   * - radio - в виде точек.
   */
  public BothVariantCheckboxStyle: "checkbox" | "radio" = "radio"

  /**
   * Текст варианта для отображения в виде одиночного чекбокса.
   * Можно задать код локализации.
   */
  public SingleVariantText: string = ""

  /**
   * Начальное состояние для одиночного чекбокса. Элементы будут
   * сразу отфильтрованы по нему.
   */
  public SingleVariantInitialState: "disabled" | "enabled" = "enabled"

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): ServicePropertySwitchSettings {
    let result = new ServicePropertySwitchSettings();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof ServicePropertySwitchSettings) => {
      // @ts-ignore
      result[key] = ServicePropertySwitchSettings.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof ServicePropertySwitchSettings>(
    field: T,
    data: any,
  ): any {
    let defaults = new ServicePropertySwitchSettings()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "Variant":
        return typeof data === "string" && ["both", "single"].includes(data) ? data : defaults[field]
      case "BothVariantCheckboxStyle":
        return typeof data === "string" && ["checkbox", "radio"].includes(data) ? data : defaults[field]
      case "SingleVariantInitialState":
        return typeof data === "string" && ["disabled", "enabled"].includes(data) ? data : defaults[field]
      case "BothVariantDisabledText":
      case "BothVariantEnabledText":
      case "BothVariantBothText":
      case "SingleVariantText":
        return typeof data === "string" ? data : defaults[field]
    }

    return defaults[field];
  }
}